import axios from 'axios';
import {createRoot} from 'react-dom/client';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';

axios.defaults.withCredentials = true;

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
  }
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}
createRoot(container).render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
